import { useThemeMode } from '../../core/theme/ThemeModeProvider'

const GRADIENT_ID = 'onboarding-logo-gradient'

// "Pass-through" mark: the arrow passing through the O stands for every branch
// request being checked here before it reaches CBS. Navy/white ink follows the
// theme; the Amnil crimson-to-orange gradient stays the same in both.
export function OnboardingLogo({ height = 26 }: { height?: number }) {
  const { mode } = useThemeMode()
  const ink = mode === 'dark' ? '#FFFFFF' : '#30305E'
  const paper = mode === 'dark' ? '#121212' : '#FFFFFF'

  return (
    <span
      aria-label='Onboarding'
      className='d-inline-flex align-items-baseline'
      style={{
        color: ink,
        fontFamily: 'Poppins, Helvetica, sans-serif',
        fontWeight: 600,
        fontSize: height,
        letterSpacing: '-0.025em',
        lineHeight: 1,
        whiteSpace: 'nowrap',
      }}
    >
      <svg
        viewBox='0 0 64 64'
        aria-hidden='true'
        style={{ height: '0.72em', width: '0.72em', marginRight: '0.015em', overflow: 'visible' }}
      >
        <defs>
          <linearGradient id={GRADIENT_ID} gradientUnits='userSpaceOnUse' x1='0' y1='0' x2='64' y2='64'>
            <stop offset='0' stopColor='#EE1A49' />
            <stop offset='1' stopColor='#FF5122' />
          </linearGradient>
        </defs>
        <circle cx='32' cy='32' r='23' fill='none' stroke={ink} strokeWidth='9' />
        <path
          d='M0 32H49M42 23L53 32L42 41'
          fill='none'
          stroke={paper}
          strokeWidth='15'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M3 32H50M42 23L53 32L42 41'
          fill='none'
          stroke={`url(#${GRADIENT_ID})`}
          strokeWidth='6'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
      nboarding
    </span>
  )
}
